import React, { useEffect, useContext } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import Axios from "axios";
import { useImmerReducer } from 'use-immer';
import {
    Grid, Snackbar, Typography, Button, TextField,
    Alert, Container, Paper, Box, CircularProgress,
    FormControl, InputLabel, Select, MenuItem, useMediaQuery, useTheme,
    FormControlLabel, Checkbox, IconButton, Tooltip
} from "@mui/material";
import { MapContainer, TileLayer, Marker, useMap } from 'react-leaflet';
import L from 'leaflet';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import { useTranslation } from 'react-i18next';
import StateContext from "../../Contexts/StateContext";
import config, { environment } from '../../config';
import LocationSelector from '../Common/LocationSelector';

const defaultIcon = new L.Icon({
    iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
});

function AddThematicPoint() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { category } = useParams();
    const GlobalState = useContext(StateContext);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const initialState = {
        nameValue: '',
        descriptionValue: '',
        birthValue: '',
        deathValue: '',
        worksValue: '',
        informantValue: '',
        collectedByValue: '',
        firstPublicationValue: '',
        selectedEditionValue: '',
        motifMarkerValue: '',
        galleryLinkValue: '',
        hashtagsValue: '',
        collectionYearValue: '',
        drawnByValue: '',
        costumeTypeValue: '',
        isChildValue: false,
        isElderlyValue: false,
        periodValue: '',
        specialNotesValue: '',
        addressValue: '',
        geocodingError: '',
        geocodingSuccess: false,
        builtYearValue: '',
        sketchValue: '',
        wallValue: '',
        floorValue: '',
        roofValue: '',
        economicBuildingsValue: '',
        otherStampsValue: '',
        gateInscriptionValue: '',
        erectedByValue: '',
        erectionYearValue: '',
        woodTypeValue: '',
        isPaintedValue: false,
        isCsangoValue: false,
        latitudeValue: 45.8643,
        longitudeValue: 25.7848,
        // Földtani fields
        regetaniKorValue: '',
        regetaniFormacioValue: '',
        kozetTipusValue: '',
        jellegzetesAsvanyValue: '',
        jellegzetesKovuletValue: '',
        thumbnailFile: null,
        imageFile: null,
        availableImages: [],
        selectedExistingImage: '',
        useExistingImage: false,
        sendRequest: 0,
        openSnack: false,
        disabledBtn: false,
        error: '',
        nameErrors: { hasError: false, errorMessage: '' },
        manualLocationSet: false,
        // Hierarchical selection
        szekOptions: [],
        kozsegOptions: [],
        telepulesOptions: [],
        selectedSzek: '',
        selectedKozseg: '',
        selectedTelepules: '',
    };

    function ourReducer(draft, action) {
        switch (action.type) {
            case 'catchNameChange':
                draft.nameValue = action.value;
                draft.nameErrors.hasError = false;
                draft.nameErrors.errorMessage = '';
                break;
            case 'catchDescriptionChange':
                draft.descriptionValue = action.value;
                break;
            case 'catchBirthChange':
                draft.birthValue = action.value;
                break;
            case 'catchDeathChange':
                draft.deathValue = action.value;
                break;
            case 'catchWorksChange':
                draft.worksValue = action.value;
                break;
            case 'catchInformantChange':
                draft.informantValue = action.value;
                break;
            case 'catchCollectedByChange':
                draft.collectedByValue = action.value;
                break;
            case 'catchFirstPublicationChange':
                draft.firstPublicationValue = action.value;
                break;
            case 'catchSelectedEditionChange':
                draft.selectedEditionValue = action.value;
                break;
            case 'catchMotifMarkerChange':
                draft.motifMarkerValue = action.value;
                break;
            case 'catchGalleryLinkChange':
                draft.galleryLinkValue = action.value;
                break;
            case 'catchHashtagsChange':
                draft.hashtagsValue = action.value;
                break;
            case 'catchCollectionYearChange':
                draft.collectionYearValue = action.value;
                break;
            case 'catchDrawnByChange':
                draft.drawnByValue = action.value;
                break;
            case 'catchCostumeTypeChange':
                draft.costumeTypeValue = action.value;
                break;
            case 'catchIsChildChange':
                draft.isChildValue = action.value;
                break;
            case 'catchIsElderlyChange':
                draft.isElderlyValue = action.value;
                break;
            case 'catchPeriodChange':
                draft.periodValue = action.value;
                break;
            case 'catchSpecialNotesChange':
                draft.specialNotesValue = action.value;
                break;
            case 'catchAddressChange':
                draft.addressValue = action.value;
                draft.geocodingError = '';
                draft.geocodingSuccess = false;
                break;
            case 'setGeocodingError':
                draft.geocodingError = action.value;
                draft.geocodingSuccess = false;
                break;
            case 'setGeocodingSuccess':
                draft.geocodingSuccess = true;
                draft.geocodingError = '';
                break;
            case 'catchBuiltYearChange':
                draft.builtYearValue = action.value;
                break;
            case 'catchSketchChange':
                draft.sketchValue = action.value;
                break;
            case 'catchWallChange':
                draft.wallValue = action.value;
                break;
            case 'catchFloorChange':
                draft.floorValue = action.value;
                break;
            case 'catchRoofChange':
                draft.roofValue = action.value;
                break;
            case 'catchEconomicBuildingsChange':
                draft.economicBuildingsValue = action.value;
                break;
            case 'catchOtherStampsChange':
                draft.otherStampsValue = action.value;
                break;
            case 'catchGateInscriptionChange':
                draft.gateInscriptionValue = action.value;
                break;
            case 'catchErectedByChange':
                draft.erectedByValue = action.value;
                break;
            case 'catchErectionYearChange':
                draft.erectionYearValue = action.value;
                break;
            case 'catchWoodTypeChange':
                draft.woodTypeValue = action.value;
                break;
            case 'catchIsPaintedChange':
                draft.isPaintedValue = action.value;
                break;
            case 'catchIsCsangoChange':
                draft.isCsangoValue = action.value;
                draft.selectedSzek = '';
                draft.selectedKozseg = '';
                draft.selectedTelepules = '';
                draft.szekOptions = [];
                draft.kozsegOptions = [];
                draft.telepulesOptions = [];
                break;
            case 'catchRegetaniKorChange':
                draft.regetaniKorValue = action.value;
                break;
            case 'catchRegetaniFormacioChange':
                draft.regetaniFormacioValue = action.value;
                break;
            case 'catchKozetTipusChange':
                draft.kozetTipusValue = action.value;
                break;
            case 'catchJellegzetesAsvanyChange':
                draft.jellegzetesAsvanyValue = action.value;
                break;
            case 'catchJellegzetesKovuletChange':
                draft.jellegzetesKovuletValue = action.value;
                break;
            case 'catchLatitudeChange':
                draft.latitudeValue = action.value;
                break;
            case 'catchLongitudeChange':
                draft.longitudeValue = action.value;
                break;
            case 'catchThumbnailChange':
                draft.thumbnailFile = action.value;
                break;
            case 'catchImageChange':
                draft.imageFile = action.value;
                break;
            case 'catchAvailableImages':
                draft.availableImages = action.value;
                break;
            case 'catchSelectedExistingImage':
                draft.selectedExistingImage = action.value;
                break;
            case 'toggleUseExistingImage':
                draft.useExistingImage = action.value;
                break;
            case 'changeSendRequest':
                draft.sendRequest++;
                break;
            case 'openTheSnack':
                draft.openSnack = true;
                break;
            case 'disableTheBtn':
                draft.disabledBtn = true;
                break;
            case 'enableTheBtn':
                draft.disabledBtn = false;
                break;
            case 'catchNameErrors':
                draft.nameErrors.hasError = true;
                draft.nameErrors.errorMessage = action.value;
                break;
            case 'setError':
                draft.error = action.value;
                break;
            case 'setSzekOptions':
                draft.szekOptions = action.value;
                break;
            case 'setKozsegOptions':
                draft.kozsegOptions = action.value;
                break;
            case 'setTelepulesOptions':
                draft.telepulesOptions = action.value;
                break;
            case 'setSelectedSzek':
                draft.selectedSzek = action.value;
                draft.selectedKozseg = '';
                draft.selectedTelepules = '';
                // Csángó esetén ne ürítsük a községeket, mert azok szék-függetlenek a jelenlegi logikában
                // Székelyföld esetén viszont üríteni kell, mert ott a szék alapján töltődnek be
                if (!draft.isCsangoValue) {
                    draft.kozsegOptions = [];
                }
                draft.telepulesOptions = [];
                break;
            case 'setSelectedKozseg':
                draft.selectedKozseg = action.value;
                draft.selectedTelepules = '';
                // Székelyföld esetén ürítsük a településeket, hogy ne maradjanak ott az előző községéi
                if (!draft.isCsangoValue) {
                    draft.telepulesOptions = [];
                }
                break;
            case 'setSelectedTelepules':
                draft.selectedTelepules = action.value;
                if (action.value) {
                    draft.manualLocationSet = true;
                }
                break;
            case 'setManualLocationSet':
                draft.manualLocationSet = action.value;
                break;
            default:
                break;
        }
    }

    const [state, dispatch] = useImmerReducer(ourReducer, initialState);

    function handleGetLocation() {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    dispatch({ type: 'catchLatitudeChange', value: position.coords.latitude });
                    dispatch({ type: 'catchLongitudeChange', value: position.coords.longitude });
                },
                (error) => {
                    console.error("Error getting location:", error);
                    dispatch({ type: 'setError', value: t('Thematic.LocationError', 'Hiba történt a helymeghatározás során.') });
                },
                { enableHighAccuracy: true }
            );
        } else {
            dispatch({ type: 'setError', value: t('Thematic.GeolocationNotSupported', 'A böngésző nem támogatja a helymeghatározást.') });
        }
    }

    useEffect(() => {
        async function fetchSzekek() {
            try {
                let url;
                if (state.isCsangoValue) {
                    // For Csango, we might not have 'szek', so we might fetch parishes directly or have a placeholder
                    // Based on Listngs.js, they use csangoKozsegVarosEndpoint
                    // But here the UI expects a 3-level hierarchy: Szek -> Kozseg -> Telepules
                    // If Csango doesn't have Szek, we can use a dummy Szek or skip it.
                    // Let's assume for now we use a dummy "Csángóföld" szek if it's Csango content
                    dispatch({ type: 'setSzekOptions', value: [{ id: 'csango', nev: 'Csángóföld' }] });
                } else {
                    url = `${config[environment].apiEndpoint}api/szek/`;
                    const response = await Axios.get(url);
                    const szekData = Array.isArray(response.data) ? response.data : (response.data.results || []);
                    const sortedSzek = [...szekData].sort((a, b) => (a.nev || a.name || '').localeCompare(b.nev || b.name || ''));
                    dispatch({ type: 'setSzekOptions', value: sortedSzek });
                }
            } catch (e) { console.error("Error fetching szekek:", e); }
        }
        fetchSzekek();
    }, [dispatch, state.isCsangoValue]);

    useEffect(() => {
        if (state.selectedSzek) {
            async function fetchKozsegek() {
                try {
                    let url;
                    if (state.isCsangoValue) {
                        const fetchAllKozsegek = async (page = 1, accumulated = []) => {
                            const response = await Axios.get(config[environment].csangoKozsegVarosEndpoint(page));
                            let data = [];
                            if (response.data.features) {
                                // GeoJSON format detected
                                data = response.data.features.map(f => ({
                                    id: f.properties.Id || f.properties.id || f.id,
                                    nev: f.properties.név || f.properties.nev || f.properties.name || f.properties.nev_hu
                                }));
                            } else {
                                const results = response.data.results || response.data || [];
                                data = (Array.isArray(results) ? results : []).map(item => ({
                                    id: item.id || item.uniqueid || item.pk,
                                    nev: item.nev || item.name || item.nev_hu
                                }));
                            }
                            const combined = [...accumulated, ...data];

                            if (response.data.next) {
                                return fetchAllKozsegek(page + 1, combined);
                            }
                            return combined;
                        };
                        const kozsegData = await fetchAllKozsegek();
                        // Egyedivé tétel és rendezés név szerint
                        const uniqueKozsegek = Array.from(new Map(kozsegData.map(item => [item.id || item.Id || item.uniqueid || item.pk, item])).values());
                        const sortedKozsegek = uniqueKozsegek.sort((a, b) => (a.nev || a.name || '').localeCompare(b.nev || b.name || ''));
                        dispatch({ type: 'setKozsegOptions', value: sortedKozsegek });
                    } else {
                        // For non-Csango, try to get ID from szekOptions if selectedSzek is a name
                        let szekId = state.selectedSzek;
                        if (state.szekOptions.length > 0) {
                            const szekObj = state.szekOptions.find(s => s.nev === state.selectedSzek || s.name === state.selectedSzek || String(s.id) === String(state.selectedSzek) || String(s.uniqueid) === String(state.selectedSzek));
                            if (szekObj) {
                                szekId = szekObj.id || szekObj.uniqueid || szekObj.pk;
                            }
                        }

                        if (szekId) {
                            // Try fetching by ID
                            try {
                                url = `${config[environment].apiEndpoint}api/kozsegvaros-dropdown/?szek=${encodeURIComponent(szekId)}`;
                                const response = await Axios.get(url);
                                const data = Array.isArray(response.data) ? response.data : (response.data.results || []);
                                if (data.length > 0) {
                                    const sortedData = [...data].sort((a, b) => (a.nev || a.name || '').localeCompare(b.nev || b.name || ''));
                                    dispatch({ type: 'setKozsegOptions', value: sortedData });
                                    return;
                                }
                            } catch (e) {
                                console.warn("Fetch by ID failed, falling back to name...", e);
                            }

                            // Fallback to name if ID failed or returned no results
                            const isNumeric = /^\d+$/.test(String(szekId));
                            if (!isNumeric || szekId !== state.selectedSzek) {
                                try {
                                    url = `${config[environment].apiEndpoint}api/kozsegvaros-dropdown/?szek_nev=${encodeURIComponent(state.selectedSzek)}`;
                                    const response = await Axios.get(url);
                                    const data = Array.isArray(response.data) ? response.data : (response.data.results || []);
                                    if (data.length > 0) {
                                        const sortedData = [...data].sort((a, b) => (a.nev || a.name || '').localeCompare(b.nev || b.name || ''));
                                        dispatch({ type: 'setKozsegOptions', value: sortedData });
                                        return;
                                    }

                                    // One more try with plain ?szek= name
                                    url = `${config[environment].apiEndpoint}api/kozsegvaros-dropdown/?szek=${encodeURIComponent(state.selectedSzek)}`;
                                    const response2 = await Axios.get(url);
                                    const data2 = Array.isArray(response2.data) ? response2.data : (response2.data.results || []);
                                    const sortedData2 = [...data2].sort((a, b) => (a.nev || a.name || '').localeCompare(b.nev || b.name || ''));
                                    dispatch({ type: 'setKozsegOptions', value: sortedData2 });
                                } catch (e) {
                                    console.error("Error fetching kozsegek by name:", e);
                                }
                            }
                        }
                    }
                } catch (e) { console.error("Error fetching kozsegek:", e); }
            }
            fetchKozsegek();
        }
    }, [state.selectedSzek, dispatch, state.isCsangoValue, state.szekOptions]);

    useEffect(() => {
        if (state.selectedKozseg) {
            async function fetchTelepulesek() {
                try {
                    let url;
                    if (state.isCsangoValue) {
                        const selectedKozsegId = state.selectedKozseg;
                        
                        if (selectedKozsegId) {
                            const fetchAllTelepulesek = async (page = 1, accumulated = []) => {
                                const response = await Axios.get(config[environment].csangoTelepulesEndpoint(page));
                                let data = [];
                                if (response.data.features) {
                                    // GeoJSON format detected
                                    data = response.data.features.map(f => ({
                                        id: f.properties.id || f.properties.Id || f.id,
                                        nev_hu: f.properties.név_hu || f.properties.nev_hu,
                                        nev_ro: f.properties.név_ro || f.properties.nev_ro,
                                        parishId: f.properties.parishId || f.properties.parish_id || f.properties.parish || f.properties.parent_id
                                    }));
                                } else {
                                    // Handle list of results or raw array
                                    const results = response.data.results || response.data || [];
                                    data = (Array.isArray(results) ? results : []).map(item => ({
                                        id: item.id || item.uniqueid || item.pk,
                                        nev_hu: item.nev_hu || item.name_hu || item.nev || item.name,
                                        nev_ro: item.nev_ro || item.name_ro || item.name,
                                        parishId: item.parishId || item.parish_id || item.parish || item.parent_id,
                                        // Backup properties for direct use
                                        ...item
                                    }));
                                }
                                const combined = [...accumulated, ...data];
                                
                                if (response.data.next) {
                                    return fetchAllTelepulesek(page + 1, combined);
                                }
                                return combined;
                            };

                            const telepulesData = await fetchAllTelepulesek();

                            // A szűrésnél a parishId mezőt hasonlítjuk össze a kiválasztott község ID-jával
                            // Fallbackként a neveket is összehasonlítjuk, ha az ID-k nem egyeznének (Csángó specifikus hiba elkerülése)
                            const selectedKozsegObj = state.kozsegOptions.find(k => String(k.id || k.Id || k.uniqueid || k.pk) === String(selectedKozsegId));
                            const selectedKozsegName = selectedKozsegObj ? (selectedKozsegObj.nev || selectedKozsegObj.name) : null;

                            const filtered = telepulesData.filter(t => 
                                (t.parishId && String(t.parishId) === String(selectedKozsegId)) ||
                                (selectedKozsegName && (
                                    (t.nev_hu && t.nev_hu === selectedKozsegName) || 
                                    (t.nev_ro && t.nev_ro === selectedKozsegName) || 
                                    (t.nev && t.nev === selectedKozsegName) ||
                                    (t.name && t.name === selectedKozsegName)
                                ))
                            );

                            const uniqueTelepulesek = Array.from(new Map(filtered.map(item => [item.id, item])).values());
                            const sortedTelepulesek = uniqueTelepulesek.sort((a, b) => (a.nev_hu || a.nev || a.name || '').localeCompare(b.nev_hu || b.nev || b.name || ''));

                            if (sortedTelepulesek.length === 0 && selectedKozsegId) {
                                console.warn("No telepules found for kozsegId:", selectedKozsegId, "attempting loose match...");
                            }

                            dispatch({ type: 'setTelepulesOptions', value: sortedTelepulesek });
                        }
                    } else {
                        // Find selected kozseg object to get reghuid
                        let selectedKozsegObj = null;
                        if (state.kozsegOptions.length > 0) {
                            selectedKozsegObj = state.kozsegOptions.find(k => (k.nev === state.selectedKozseg || k.name === state.selectedKozseg || k.uniqueid === state.selectedKozseg || String(k.id) === String(state.selectedKozseg)));
                        }

                        if (selectedKozsegObj && selectedKozsegObj.reghuid) {
                            url = `${config[environment].apiEndpoint}api/telepules-dropdown/?reghuid=${selectedKozsegObj.reghuid}`;
                            const response = await Axios.get(url);
                            const data = Array.isArray(response.data) ? response.data : (response.data.results || []);
                            const sortedData = [...data].sort((a, b) => (a.nev_hu || a.nev || a.name || '').localeCompare(b.nev_hu || b.nev || b.name || ''));
                            dispatch({ type: 'setTelepulesOptions', value: sortedData });
                        } else if (state.selectedKozseg) {
                            // Fallback if reghuid is not available
                            const isId = /^\d+$/.test(String(state.selectedKozseg));
                            if (isId) {
                                url = `${config[environment].apiEndpoint}api/telepules-dropdown/?kozseg=${state.selectedKozseg}`;
                            } else {
                                const endpoints = [
                                    `${config[environment].apiEndpoint}api/telepules-dropdown/?kozseg_nev=${encodeURIComponent(state.selectedKozseg)}`,
                                    `${config[environment].apiEndpoint}api/telepules-dropdown/?kozsegvaros__nev=${encodeURIComponent(state.selectedKozseg)}`,
                                    `${config[environment].apiEndpoint}api/telepules-dropdown/?szek=${encodeURIComponent(state.selectedSzek)}&kozseg=${encodeURIComponent(state.selectedKozseg)}`,
                                    `${config[environment].apiEndpoint}api/telepules-dropdown/?szek_nev=${encodeURIComponent(state.selectedSzek)}&kozseg_nev=${encodeURIComponent(state.selectedKozseg)}`,
                                    `${config[environment].apiEndpoint}api/telepules/?kozsegvaros__nev=${encodeURIComponent(state.selectedKozseg)}`
                                ];

                                for (const ep of endpoints) {
                                    try {
                                        const response = await Axios.get(ep);
                                        const data = Array.isArray(response.data) ? response.data : (response.data.results || []);
                                        if (data.length > 0) {
                                            const sortedData = [...data].sort((a, b) => (a.nev_hu || a.nev || a.name || '').localeCompare(b.nev_hu || b.nev || b.name || ''));
                                            dispatch({ type: 'setTelepulesOptions', value: sortedData });
                                            return;
                                        }
                                    } catch (e) { /* continue */ }
                                }
                                return;
                            }
                            const response = await Axios.get(url);
                            const data = Array.isArray(response.data) ? response.data : (response.data.results || []);
                            const sortedData = [...data].sort((a, b) => (a.nev_hu || a.nev || a.name || '').localeCompare(b.nev_hu || b.nev || b.name || ''));
                            dispatch({ type: 'setTelepulesOptions', value: sortedData });
                        }
                    }
                } catch (e) { console.error("Error fetching telepulesek:", e); }
            }
            fetchTelepulesek();
        }
    }, [state.selectedKozseg, state.kozsegOptions, dispatch, state.isCsangoValue]);

    useEffect(() => {
        if (state.selectedTelepules && state.manualLocationSet) {
            async function fetchCentroid() {
                try {
                    let url;
                    const selectedTelepulesObj = state.telepulesOptions.find(t => 
                        String(t.id) === String(state.selectedTelepules) || 
                        String(t.uniqueid) === String(state.selectedTelepules) || 
                        String(t.pk) === String(state.selectedTelepules) ||
                        (t.nev_hu === state.selectedTelepules) ||
                        (t.nev === state.selectedTelepules) ||
                        (t.name === state.selectedTelepules)
                    );

                    if (state.isCsangoValue) {
                        if (selectedTelepulesObj && selectedTelepulesObj.geom) {
                            if (selectedTelepulesObj.geom.type === 'Point') {
                                dispatch({ type: 'catchLatitudeChange', value: selectedTelepulesObj.geom.coordinates[1] });
                                dispatch({ type: 'catchLongitudeChange', value: selectedTelepulesObj.geom.coordinates[0] });
                                dispatch({ type: 'setManualLocationSet', value: false });
                                return;
                            }
                        }
                        url = `${config[environment].apiEndpoint}api/csango-telepules/${state.selectedTelepules}/centroid/`;
                    } else {
                        // Use ID if found in telepulesOptions for Szekler settlements too
                        if (selectedTelepulesObj && (selectedTelepulesObj.id || selectedTelepulesObj.uniqueid || selectedTelepulesObj.pk)) {
                            const tId = selectedTelepulesObj.id || selectedTelepulesObj.uniqueid || selectedTelepulesObj.pk;
                            url = `${config[environment].apiEndpoint}api/telepules/${tId}/centroid/`;
                        } else {
                            url = `${config[environment].apiEndpoint}api/telepules/${encodeURIComponent(state.selectedTelepules)}/centroid/`;
                        }
                    }
                    const response = await Axios.get(url);
                    dispatch({ type: 'catchLatitudeChange', value: response.data.latitude });
                    dispatch({ type: 'catchLongitudeChange', value: response.data.longitude });
                } catch (e) { 
                    console.error("Error fetching centroid:", e); 
                } finally {
                    dispatch({ type: 'setManualLocationSet', value: false });
                }
            }
            fetchCentroid();
        }
    }, [state.selectedTelepules, dispatch, state.isCsangoValue, state.telepulesOptions, state.manualLocationSet]);

    useEffect(() => {
        async function fetchAvailableImages() {
            const token = GlobalState.jwtAccessToken || localStorage.getItem('token');
            
            if (!token) {
                return;
            }
            
            try {
                const url = `${config[environment].apiEndpoint}api/thematic-maps/available-images/?category=${category}`;
                const response = await Axios.get(url, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                dispatch({ type: 'catchAvailableImages', value: response.data.images });
            } catch (e) {
            }
        }
        fetchAvailableImages();
    }, [category, GlobalState.jwtAccessToken, dispatch]);

    function TheMapComponent() {
        const map = useMap();
        useEffect(() => {
            L.DomUtil.addClass(map.getContainer(), 'crosshair-cursor-enabled');
            const style = document.createElement('style');
            style.innerHTML = '.crosshair-cursor-enabled { cursor: crosshair !important; }';
            document.head.appendChild(style);

            map.on('click', function (e) {
                dispatch({ type: 'catchLatitudeChange', value: e.latlng.lat });
                dispatch({ type: 'catchLongitudeChange', value: e.latlng.lng });
                dispatch({ type: 'setManualLocationSet', value: false });
            });

            return () => {
                L.DomUtil.removeClass(map.getContainer(), 'crosshair-cursor-enabled');
                document.head.removeChild(style);
            };
        }, [map]);
        return null;
    }

    function MapFlyTo({ location }) {
        const map = useMap();
        useEffect(() => {
            if (location[0] && location[1]) {
                map.flyTo(location, 13);
            }
        }, [location, map]);
        return null;
    }

    const getTitle = () => {
        switch (category) {
            case 'nepviselet': return t('Thematic.FolkCostume', 'Népviselet');
            case 'nepi_epiteszet': return t('Thematic.FolkArchitecture', 'Népi építészet');
            case 'szekelykapu': return t('Thematic.Szekelykapu', 'Székelykapu');
            case 'panteon': return t('Thematic.Pantheon', 'Panteon');
            case 'futuristique': return t('Thematic.Futuristique', 'Futuristique');
            case 'ballada': return t('Thematic.Ballada', 'Ballada');
            case 'nepdal': return t('Thematic.Nepdal', 'Népdal');
            case 'locsoloversek': return t('Thematic.Locsoloversek', 'Locsolóversek');
            default: return t('Header.ThematicMaps', 'Tematikus térkép');
        }
    };

    const handleGeocode = async () => {
        if (!state.addressValue) return;
        try {
            const response = await Axios.get(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(state.addressValue)}`);
            if (response.data && response.data.length > 0) {
                const { lat, lon } = response.data[0];
                dispatch({ type: 'catchLatitudeChange', value: parseFloat(lat) });
                dispatch({ type: 'catchLongitudeChange', value: parseFloat(lon) });
                dispatch({ type: 'setGeocodingSuccess' });
            } else {
                dispatch({ type: 'setGeocodingError', value: t('Thematic.GeocodingNoResult', 'Nem található koordináta a megadott címhez.') });
            }
        } catch (e) {
            console.error("Geocoding error:", e);
            dispatch({ type: 'setGeocodingError', value: t('Thematic.GeocodingError', 'Hiba történt a keresés során.') });
        }
    };

    function FormSubmit(e) {
        e.preventDefault();
        if (!state.nameValue) {
            dispatch({ type: 'catchNameErrors', value: t('Validation.EmptyName', 'A név megadása kötelező!') });
            return;
        }
        dispatch({ type: 'changeSendRequest' });
        dispatch({ type: 'disableTheBtn' });
    }

    useEffect(() => {
        if (state.sendRequest) {
            async function SubmitFunc() {
                const token = GlobalState.jwtAccessToken || localStorage.getItem('token');
                if (!token) {
                    dispatch({ type: 'setError', value: t('Administration.LoginRequired', 'A folytatáshoz be kell jelentkeznie.') });
                    dispatch({ type: 'enableTheBtn' });
                    return;
                }
                
                const formData = new FormData();
                formData.append('name', state.nameValue);
                formData.append('description', state.descriptionValue);
                formData.append('birth', state.birthValue);
                formData.append('death', state.deathValue);
                formData.append('works', state.worksValue);
                formData.append('informant', state.informantValue);
                formData.append('collected_by', state.collectedByValue);
                formData.append('first_publication', state.firstPublicationValue);
                formData.append('selected_edition', state.selectedEditionValue);
                formData.append('motif_marker', state.motifMarkerValue);
                formData.append('collection_year', state.collectionYearValue);
                formData.append('drawn_by', state.drawnByValue);
                formData.append('costume_type', state.costumeTypeValue);
                formData.append('is_child', state.isChildValue);
                formData.append('is_elderly', state.isElderlyValue);
                formData.append('period', state.periodValue);
                formData.append('special_notes', state.specialNotesValue);
                formData.append('address', state.addressValue);
                formData.append('built_year', state.builtYearValue);
                formData.append('sketch', state.sketchValue);
                formData.append('wall', state.wallValue);
                formData.append('floor', state.floorValue);
                formData.append('roof', state.roofValue);
                formData.append('economic_buildings', state.economicBuildingsValue);
                formData.append('other_stamps', state.otherStampsValue);
                formData.append('gate_inscription', state.gateInscriptionValue);
                formData.append('erected_by', state.erectedByValue);
                formData.append('erection_year', state.erectionYearValue);
                formData.append('wood_type', state.woodTypeValue);
                formData.append('is_painted', state.isPaintedValue);
                formData.append('is_csango', state.isCsangoValue);
                formData.append('gallery_link', state.galleryLinkValue);
                formData.append('hashtags', state.hashtagsValue);
                formData.append('category', category);
                formData.append('geom', `POINT(${state.longitudeValue} ${state.latitudeValue})`);
                
                // Földtani fields
                formData.append('stratigraphic_age', state.regetaniKorValue);
                formData.append('stratigraphic_formation', state.regetaniFormacioValue);
                formData.append('rock_type', state.kozetTipusValue);
                formData.append('characteristic_mineral', state.jellegzetesAsvanyValue);
                formData.append('characteristic_fossil', state.jellegzetesKovuletValue);
                
                // Hierarchical location
                if (state.selectedSzek) formData.append('szek', state.selectedSzek);
                if (state.selectedKozseg) formData.append('kozsegvaros', state.selectedKozseg);
                if (state.selectedTelepules) formData.append('telepules', state.selectedTelepules);
                
                if (state.useExistingImage && state.selectedExistingImage) {
                    formData.append('existing_image', state.selectedExistingImage);
                } else {
                    if (state.thumbnailFile) formData.append('thumbnail', state.thumbnailFile);
                    if (state.imageFile) formData.append('image', state.imageFile);
                }


                try {
                    const tokenForHeader = GlobalState.jwtAccessToken || localStorage.getItem('token');
                    const url = `${config[environment].apiEndpoint}api/thematic-maps/points/create/`;
                    
                    const response = await Axios.post(url, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'Authorization': `Bearer ${tokenForHeader}`,
                            'Accept': 'application/json'
                        }
                    });
                    dispatch({ type: 'openTheSnack' });
                } catch (e) {
                    if (e.response && e.response.status === 401) {
                    }
                    dispatch({ type: 'enableTheBtn' });
                    dispatch({ type: 'setError', value: e.response?.status === 401 ? t('Administration.LoginRequired', 'A folytatáshoz be kell jelentkeznie (lejárt munkamenet).') : t('Common.Error', 'Hiba történt a mentés során.') });
                }
            }
            SubmitFunc();
        }
    }, [state.sendRequest, GlobalState.jwtAccessToken, dispatch, state.addressValue, state.birthValue, state.builtYearValue, state.collectedByValue, state.collectionYearValue, state.costumeTypeValue, state.deathValue, state.descriptionValue, state.drawnByValue, state.economicBuildingsValue, state.erectedByValue, state.erectionYearValue, state.firstPublicationValue, state.floorValue, state.galleryLinkValue, state.gateInscriptionValue, state.hashtagsValue, state.imageFile, state.informantValue, state.isChildValue, state.isElderlyValue, state.isPaintedValue, state.isCsangoValue, state.latitudeValue, state.longitudeValue, state.motifMarkerValue, state.nameValue, state.otherStampsValue, state.periodValue, state.roofValue, state.selectedEditionValue, state.selectedExistingImage, state.selectedKozseg, state.selectedSzek, state.selectedTelepules, state.sketchValue, state.specialNotesValue, state.thumbnailFile, state.useExistingImage, state.wallValue, state.woodTypeValue, state.worksValue, t]);

    useEffect(() => {
        if (state.openSnack) {
            setTimeout(() => {
                navigate(-1);
            }, 1500);
        }
    }, [state.openSnack, navigate]);

    if (!GlobalState.userIsLogged) {
        return (
            <Container maxWidth="sm" sx={{ py: 8 }}>
                <Alert severity="warning">
                    {t('Administration.LoginRequired')}
                </Alert>
                <Button variant="contained" onClick={() => navigate('/login')} sx={{ mt: 2 }}>
                    {t('Administration.LoginButton')}
                </Button>
            </Container>
        );
    }

    return (
        <Container maxWidth="md" sx={{ py: { xs: 2, md: 4 }, px: { xs: 1, sm: 2 }, mt: '100px' }}>
            <Paper sx={{ p: { xs: 2, md: 4 } }}>
                <Typography variant={isMobile ? "h5" : "h4"} gutterBottom sx={{ color: '#105b79', fontWeight: 'bold' }}>
                    {getTitle()} +
                </Typography>
                
                <form onSubmit={FormSubmit}>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label={t('Common.Name')}
                                value={state.nameValue}
                                onChange={(e) => dispatch({ type: 'catchNameChange', value: e.target.value })}
                                error={state.nameErrors.hasError}
                                helperText={state.nameErrors.errorMessage}
                                required
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                multiline
                                minRows={['ballada', 'nepdal', 'locsoloversek'].includes(category) ? (isMobile ? 6 : 8) : (isMobile ? 3 : 4)}
                                label={category === 'ballada' ? t('Thematic.BalladText') :
                                       category === 'nepdal' ? t('Thematic.FolkSongText') :
                                       category === 'locsoloversek' ? t('Thematic.EasterVerseText') :
                                       t('Common.Description')}
                                value={state.descriptionValue}
                                onChange={(e) => dispatch({ type: 'catchDescriptionChange', value: e.target.value })}
                            />
                        </Grid>

                        {category === 'panteon' && (
                            <>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label={t('Thematic.Birth', 'Született')}
                                        value={state.birthValue}
                                        onChange={(e) => dispatch({ type: 'catchBirthChange', value: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label={t('Thematic.Death', 'Elhunyt')}
                                        value={state.deathValue}
                                        onChange={(e) => dispatch({ type: 'catchDeathChange', value: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        multiline
                                        minRows={10}
                                        label={t('Thematic.Works', 'Művei')}
                                        value={state.worksValue}
                                        onChange={(e) => dispatch({ type: 'catchWorksChange', value: e.target.value })}
                                    />
                                </Grid>
                            </>
                        )}

                        {category === 'nepviselet' && (
                            <>
                                <Grid item xs={12}>
                                    <Typography variant="h6" sx={{ color: '#105b79', fontWeight: 'bold', mt: 2, mb: 1 }}>
                                        {t('Thematic.FolkCostumeDetails')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label={t('Thematic.CollectionYear', 'Gyűjtés éve')}
                                        value={state.collectionYearValue}
                                        onChange={(e) => dispatch({ type: 'catchCollectionYearChange', value: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label={t('Thematic.CollectedBy', 'Gyűjtő neve')}
                                        value={state.collectedByValue}
                                        onChange={(e) => dispatch({ type: 'catchCollectedByChange', value: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label={t('Thematic.DrawnBy', 'Rajzolta')}
                                        value={state.drawnByValue}
                                        onChange={(e) => dispatch({ type: 'catchDrawnByChange', value: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth>
                                        <InputLabel>{t('Thematic.CostumeType', 'Viselet típusa')}</InputLabel>
                                        <Select
                                            value={state.costumeTypeValue}
                                            label={t('Thematic.CostumeType', 'Viselet típusa')}
                                            onChange={(e) => dispatch({ type: 'catchCostumeTypeChange', value: e.target.value })}
                                        >
                                            <MenuItem value="férfi">{t('Thematic.Male')}</MenuItem>
                                            <MenuItem value="női">{t('Thematic.Female')}</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={state.isChildValue}
                                                onChange={(e) => dispatch({ type: 'catchIsChildChange', value: e.target.checked })}
                                            />
                                        }
                                        label={t('Thematic.IsChild', 'Gyermek/ fiatal')}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={state.isElderlyValue}
                                                onChange={(e) => dispatch({ type: 'catchIsElderlyChange', value: e.target.checked })}
                                            />
                                        }
                                        label={t('Thematic.IsElderly', 'Idős viselet')}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label={t('Thematic.Period', 'Viselet időszaka (pl. böjti, házasságkötés)')}
                                        value={state.periodValue}
                                        onChange={(e) => dispatch({ type: 'catchPeriodChange', value: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        multiline
                                        minRows={4}
                                        label={t('Thematic.SpecialNotes', 'Speciális')}
                                        value={state.specialNotesValue}
                                        onChange={(e) => dispatch({ type: 'catchSpecialNotesChange', value: e.target.value })}
                                    />
                                </Grid>
                            </>
                        )}

                        {category === 'nepi_epiteszet' && (
                            <>
                                <Grid item xs={12}>
                                    <Typography variant="h6" sx={{ color: '#105b79', fontWeight: 'bold', mt: 2, mb: 1 }}>
                                        {t('Thematic.FolkArchitectureDetails')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={9}>
                                    <TextField
                                        fullWidth
                                        label={t('Common.Address')}
                                        value={state.addressValue}
                                        onChange={(e) => dispatch({ type: 'catchAddressChange', value: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <Button
                                        fullWidth
                                        variant="outlined"
                                        onClick={handleGeocode}
                                        sx={{ height: '56px' }}
                                    >
                                        {t('Thematic.Geocode')}
                                    </Button>
                                </Grid>
                                {state.geocodingError && (
                                    <Grid item xs={12}>
                                        <Alert severity="error" sx={{ mt: 1 }}>
                                            {state.geocodingError}
                                        </Alert>
                                    </Grid>
                                )}
                                {state.geocodingSuccess && (
                                    <Grid item xs={12}>
                                        <Alert severity="success" sx={{ mt: 1 }}>
                                            {t('Thematic.GeocodingSuccess')}
                                        </Alert>
                                    </Grid>
                                )}
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label={t('Thematic.BuiltYear', 'Épült (évszám)')}
                                        value={state.builtYearValue}
                                        onChange={(e) => dispatch({ type: 'catchBuiltYearChange', value: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label={t('Thematic.CollectedBy', 'Gyűjtötte')}
                                        value={state.collectedByValue}
                                        onChange={(e) => dispatch({ type: 'catchCollectedByChange', value: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label={t('Thematic.Sketch', 'Vázlatrajz')}
                                        value={state.sketchValue}
                                        onChange={(e) => dispatch({ type: 'catchSketchChange', value: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label={t('Thematic.Wall', 'Falazat')}
                                        value={state.wallValue}
                                        onChange={(e) => dispatch({ type: 'catchWallChange', value: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label={t('Thematic.Floor', 'Födém')}
                                        value={state.floorValue}
                                        onChange={(e) => dispatch({ type: 'catchFloorChange', value: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label={t('Thematic.Roof', 'Héjazat')}
                                        value={state.roofValue}
                                        onChange={(e) => dispatch({ type: 'catchRoofChange', value: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        multiline
                                        minRows={2}
                                        label={t('Thematic.EconomicBuildings', 'Gazdasági épületek')}
                                        value={state.economicBuildingsValue}
                                        onChange={(e) => dispatch({ type: 'catchEconomicBuildingsChange', value: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        multiline
                                        minRows={2}
                                        label={t('Thematic.OtherStamps', 'Egyéb bélyegek')}
                                        value={state.otherStampsValue}
                                        onChange={(e) => dispatch({ type: 'catchOtherStampsChange', value: e.target.value })}
                                    />
                                </Grid>
                            </>
                        )}

                        {(category === 'ballada' || category === 'nepdal' || category === 'locsoloversek') && (
                            <>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        label={t('Thematic.MotifMarker', 'Motívumjelölő')}
                                        value={state.motifMarkerValue}
                                        onChange={(e) => dispatch({ type: 'catchMotifMarkerChange', value: e.target.value })}
                                        helperText={t('Thematic.MotifMarkerHelper', 'Gyakorlatilag az alcím, pl. Pendzsóka (A jávorfa-muzsika)')}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label={t('Thematic.Informant', 'Adatközlő')}
                                        value={state.informantValue}
                                        onChange={(e) => dispatch({ type: 'catchInformantChange', value: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label={t('Thematic.CollectedBy', 'Gyűjtötte')}
                                        value={state.collectedByValue}
                                        onChange={(e) => dispatch({ type: 'catchCollectedByChange', value: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label={t('Thematic.FirstPublication', 'Első közlés')}
                                        value={state.firstPublicationValue}
                                        onChange={(e) => dispatch({ type: 'catchFirstPublicationChange', value: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        multiline
                                        minRows={3}
                                        label={t('Thematic.SelectedEdition', 'Válogatott kiadás')}
                                        value={state.selectedEditionValue}
                                        onChange={(e) => dispatch({ type: 'catchSelectedEditionChange', value: e.target.value })}
                                    />
                                </Grid>
                            </>
                        )}

                        {category === 'szekelykapu' && (
                            <>
                                <Grid item xs={12}>
                                    <Typography variant="h6" sx={{ color: '#105b79', fontWeight: 'bold', mt: 2, mb: 1 }}>
                                        {t('Thematic.SzekelykapuDetails')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        multiline
                                        minRows={3}
                                        label={t('Thematic.GateInscription', 'Kapufelirat')}
                                        value={state.gateInscriptionValue}
                                        onChange={(e) => dispatch({ type: 'catchGateInscriptionChange', value: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label={t('Thematic.ErectedBy', 'Állíttatta')}
                                        value={state.erectedByValue}
                                        onChange={(e) => dispatch({ type: 'catchErectedByChange', value: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label={t('Thematic.ErectionYear', 'A kapuállítás éve')}
                                        value={state.erectionYearValue}
                                        onChange={(e) => dispatch({ type: 'catchErectionYearChange', value: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label={t('Thematic.WoodType', 'A fa fajtája')}
                                        value={state.woodTypeValue}
                                        onChange={(e) => dispatch({ type: 'catchWoodTypeChange', value: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={state.isPaintedValue}
                                                onChange={(e) => dispatch({ type: 'catchIsPaintedChange', value: e.target.checked })}
                                            />
                                        }
                                        label={t('Thematic.IsPainted', 'Festett')}
                                    />
                                </Grid>
                            </>
                        )}

                        {category === 'foldtani' && (
                            <>
                                <Grid item xs={12}>
                                    <Typography variant="h6" sx={{ color: '#105b79', fontWeight: 'bold', mt: 2, mb: 1 }}>
                                        {t('Thematic.FoldtaniFeltarasok', 'Földtani feltárások')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label={t('Thematic.StratigraphicAge')}
                                        value={state.regetaniKorValue}
                                        onChange={(e) => dispatch({ type: 'catchRegetaniKorChange', value: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label={t('Thematic.StratigraphicFormation')}
                                        value={state.regetaniFormacioValue}
                                        onChange={(e) => dispatch({ type: 'catchRegetaniFormacioChange', value: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label={t('Thematic.RockType')}
                                        value={state.kozetTipusValue}
                                        onChange={(e) => dispatch({ type: 'catchKozetTipusChange', value: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label={t('Thematic.CharacteristicMineral')}
                                        value={state.jellegzetesAsvanyValue}
                                        onChange={(e) => dispatch({ type: 'catchJellegzetesAsvanyChange', value: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label={t('Thematic.CharacteristicFossil')}
                                        value={state.jellegzetesKovuletValue}
                                        onChange={(e) => dispatch({ type: 'catchJellegzetesKovuletChange', value: e.target.value })}
                                    />
                                </Grid>
                            </>
                        )}

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label={t('Thematic.GalleryLink', 'Galéria link')}
                                value={state.galleryLinkValue}
                                onChange={(e) => dispatch({ type: 'catchGalleryLinkChange', value: e.target.value })}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label={t('Thematic.Hashtags', 'Hashtagek')}
                                placeholder="#jovo, #fejlesztes"
                                helperText={t('Thematic.HashtagsHelper', 'Vesszővel elválasztott hashtagek')}
                                value={state.hashtagsValue}
                                onChange={(e) => dispatch({ type: 'catchHashtagsChange', value: e.target.value })}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Typography variant="h6" gutterBottom>
                                {t('Common.Location')}
                            </Typography>
                            {category === 'foldtani' && (
                                <Alert severity="info" sx={{ mb: 2 }}>
                                    {t('Thematic.ClickToPlacePin', 'Kattintson a térképre a feltárás pontos helyének megjelöléséhez!')}
                                </Alert>
                            )}
                            {(category === 'nepviselet' || category === 'ballada' || category === 'nepdal' || category === 'locsoloversek') && (
                                <Box sx={{ mb: 2 }}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={state.isCsangoValue}
                                                onChange={(e) => dispatch({ type: 'catchIsCsangoChange', value: e.target.checked })}
                                                color="primary"
                                            />
                                        }
                                        label={t('Thematic.IsCsango', 'Csángó tartalom')}
                                    />
                                </Box>
                            )}
                            {category !== 'foldtani' && (
                                <Grid container spacing={2} sx={{ mb: 2 }}>
                                    <Grid item xs={12} sm={4}>
                                        <FormControl fullWidth>
                                            <InputLabel>{t('Map.Toolbox.szek')}</InputLabel>
                                            <Select
                                                value={state.selectedSzek}
                                                label={t('Map.Toolbox.szek')}
                                                onChange={(e) => dispatch({ type: 'setSelectedSzek', value: e.target.value })}
                                                MenuProps={{
                                                    PaperProps: {
                                                        style: {
                                                            maxHeight: 300,
                                                        },
                                                    },
                                                }}
                                            >
                                                {state.szekOptions.map((sz, index) => (
                                                    <MenuItem key={`${sz.id || sz.uniqueid || sz.pk || 'szek'}-${index}`} value={state.isCsangoValue ? (sz.id || sz.uniqueid || sz.pk) : sz.nev}>{sz.nev || sz.name}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <FormControl fullWidth disabled={!state.selectedSzek}>
                                            <InputLabel>{t('Map.Toolbox.kozseg')}</InputLabel>
                                            <Select
                                                value={state.selectedKozseg}
                                                label={t('Map.Toolbox.kozseg')}
                                                onChange={(e) => dispatch({ type: 'setSelectedKozseg', value: e.target.value })}
                                                required={state.isCsangoValue}
                                                MenuProps={{
                                                    PaperProps: {
                                                        style: {
                                                            maxHeight: 300,
                                                        },
                                                    },
                                                }}
                                            >
                                                {state.kozsegOptions.map((k, index) => (
                                                    <MenuItem key={`${k.id || k.uniqueid || k.pk || 'kozseg'}-${index}`} value={state.isCsangoValue ? (k.id || k.uniqueid || k.pk) : (k.nev || k.uniqueid)}>{k.nev || k.name}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <FormControl fullWidth disabled={!state.selectedKozseg}>
                                            <InputLabel>{t('Map.Toolbox.telepules')}</InputLabel>
                                            <Select
                                                value={state.selectedTelepules}
                                                label={t('Map.Toolbox.telepules')}
                                                onChange={(e) => dispatch({ type: 'setSelectedTelepules', value: e.target.value })}
                                                required={state.isCsangoValue}
                                                MenuProps={{
                                                    PaperProps: {
                                                        style: {
                                                            maxHeight: 300,
                                                        },
                                                    },
                                                }}
                                            >
                                                {state.telepulesOptions.map((t_opt, index) => (
                                                    <MenuItem key={`${t_opt.id || t_opt.uniqueid || t_opt.pk || 'telepules'}-${index}`} value={state.isCsangoValue ? (t_opt.id || t_opt.uniqueid || t_opt.pk) : (t_opt.nev_hu || t_opt.nev || t_opt.name || String(t_opt.id))}>{t_opt.nev_hu || t_opt.nev || t_opt.name}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            )}

                            <Box sx={{ height: isMobile ? '300px' : '400px', width: '100%', position: 'relative' }}>
                                {category === 'foldtani' && (
                                    <Box sx={{ position: 'absolute', top: 10, right: 10, zIndex: 1000 }}>
                                        <Tooltip title={t('Thematic.GetCurrentLocation', 'Jelenlegi pozíció lekérése')}>
                                            <IconButton 
                                                onClick={handleGetLocation}
                                                sx={{ 
                                                    bgcolor: 'white', 
                                                    '&:hover': { bgcolor: '#f5f5f5' },
                                                    boxShadow: 2
                                                }}
                                                color="primary"
                                            >
                                                <MyLocationIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </Box>
                                )}
                                <MapContainer 
                                    center={[state.latitudeValue, state.longitudeValue]} 
                                    zoom={13} 
                                    style={{ height: '100%', borderRadius: '8px' }}
                                >
                                    <TileLayer url={config[environment].osmTiles} />
                                    <TheMapComponent />
                                    <MapFlyTo location={[state.latitudeValue, state.longitudeValue]} />
                                    <Marker position={[state.latitudeValue, state.longitudeValue]} icon={defaultIcon} />
                                </MapContainer>
                            </Box>
                        </Grid>

                        <Grid item xs={12}>
                            <Box sx={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', alignItems: 'stretch', gap: 2, mb: 2 }}>
                                <Button 
                                    variant={state.useExistingImage ? "outlined" : "contained"} 
                                    onClick={() => dispatch({ type: 'toggleUseExistingImage', value: false })}
                                    sx={{ flex: 1 }}
                                >
                                    {t('Thematic.UploadNew', 'Új képek feltöltése')}
                                </Button>
                                <Button 
                                    variant={state.useExistingImage ? "contained" : "outlined"} 
                                    onClick={() => dispatch({ type: 'toggleUseExistingImage', value: true })}
                                    disabled={state.availableImages.length === 0}
                                    sx={{ flex: 1 }}
                                >
                                    {t('Thematic.UseExisting', 'Létező kép használata')}
                                </Button>
                            </Box>
                        </Grid>

                        {!state.useExistingImage ? (
                            <>
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle2" gutterBottom>{t('Thematic.Thumbnail', 'Thumbnail kép')}</Typography>
                                    <Button variant="outlined" component="label" fullWidth sx={{ textTransform: 'none', py: 1 }}>
                                        <Typography variant="body2" noWrap sx={{ maxWidth: '100%' }}>
                                            {state.thumbnailFile ? state.thumbnailFile.name : t('Common.ChooseFile', 'Fájl kiválasztása')}
                                        </Typography>
                                        <input type="file" hidden accept="image/*" onChange={(e) => dispatch({ type: 'catchThumbnailChange', value: e.target.files[0] })} />
                                    </Button>
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle2" gutterBottom>{t('Thematic.LargeImage', 'Nagy kép')}</Typography>
                                    <Button variant="outlined" component="label" fullWidth sx={{ textTransform: 'none', py: 1 }}>
                                        <Typography variant="body2" noWrap sx={{ maxWidth: '100%' }}>
                                            {state.imageFile ? state.imageFile.name : t('Common.ChooseFile', 'Fájl kiválasztása')}
                                        </Typography>
                                        <input type="file" hidden accept="image/*" onChange={(e) => dispatch({ type: 'catchImageChange', value: e.target.files[0] })} />
                                    </Button>
                                </Grid>
                            </>
                        ) : (
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <InputLabel>{t('Thematic.SelectImage', 'Válasszon képet')}</InputLabel>
                                    <Select
                                        value={state.selectedExistingImage}
                                        label={t('Thematic.SelectImage', 'Válasszon képet')}
                                        onChange={(e) => dispatch({ type: 'catchSelectedExistingImage', value: e.target.value })}
                                    >
                                        {state.availableImages.sort((a, b) => a.localeCompare(b)).map((img) => (
                                            <MenuItem key={img} value={img}>{img}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <Typography variant="caption" sx={{ mt: 1, display: 'block' }}>
                                    {t('Thematic.ExistingImageNote', 'A kiválasztott kép lesz használva nagy képként és thumbnailként is.')}
                                </Typography>
                            </Grid>
                        )}
                    </Grid>

                    {state.error && <Alert severity="error" sx={{ mt: 3 }}>{state.error}</Alert>}

                    <Box sx={{ mt: 4, display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: 2 }}>
                        <Button
                            type="submit"
                            variant="contained"
                            size="large"
                            disabled={state.disabledBtn}
                            sx={{ bgcolor: '#105b79', flex: isMobile ? 'none' : 1, order: isMobile ? 1 : 1 }}
                        >
                            {state.disabledBtn ? <CircularProgress size={24} color="inherit" /> : t('Common.Submit', 'Beküldés')}
                        </Button>
                        <Button variant="outlined" size="large" onClick={() => navigate(-1)} sx={{ flex: isMobile ? 'none' : 1, order: isMobile ? 2 : 2 }}>
                            {t('Common.Cancel', 'Mégse')}
                        </Button>
                    </Box>
                </form>
            </Paper>

            <Snackbar open={state.openSnack} autoHideDuration={3000} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
                <Alert severity="success" sx={{ width: '100%' }}>
                    {t('Common.Success', 'Sikeres mentés!')}
                </Alert>
            </Snackbar>
        </Container>
    );
}

export default AddThematicPoint;
